import { Center, forwardRef, Input, SimpleGrid, Text } from "@chakra-ui/react";
import type { ComponentProps } from "react";
import type { ISubscriptionPlanByPkQuery } from "../../../../lib/api/sdk";
import { INPUT_SPACING } from "../../RegisterPage";
import SusbcriptionTypeCard from "./SubscriptionTypeCard";
import { useTranslations } from "next-intl";

interface IPricesProps extends ComponentProps<any> {
  data?: ISubscriptionPlanByPkQuery;
  loading?: boolean;
  onChange: (value: any) => any;
  value: string;
}

const Prices = forwardRef(
  ({ data, loading, value, onChange, ...props }: IPricesProps, ref: any) => {
    const t = useTranslations("pages.register");
    const subscription_plan = data?.subscription_plan_by_pk;

    const subscriptionPlanPrices = [
      { interval: 4, discount: 0 },
      { interval: 12, discount: subscription_plan?.quarterly_discount || 0 },
      { interval: 24, discount: subscription_plan?.biannualy_discount || 0 },
      { interval: 48, discount: subscription_plan?.yearly_discount || 0 },
    ];

    const GetStripePriceId = (billing_interval: number) => {
      return (
        data?.subscription_plan_by_pk?.subscription_plan_prices.find(
          price => price.interval_count === billing_interval
        )?.stripe_lookup_key || null
      );
    };

    const GetPlanFullPrice = (billing_interval: number) => {
      return (subscription_plan?.weekly_price || 0) * billing_interval;
    };

    return (
      <>
        <Input
          {...props}
          ref={ref}
          value={value}
          onChange={onChange}
          display={"none"}
        />
        <SimpleGrid columns={[1, 1, 2, 2]} spacing={INPUT_SPACING} w="full">
          {loading
            ? [0, 1, 2, 3].map(i => (
              <SusbcriptionTypeCard
                key={i}
                isSelected={false}
                onClick={() => null}
                isLoading
              />
            ))
            : !!subscription_plan?.subscription_plan_prices.length &&
              subscriptionPlanPrices.map(({ interval, discount }) => (
              <SusbcriptionTypeCard
                key={interval}
                isSelected={value === GetStripePriceId(interval)}
                onClick={() => onChange(GetStripePriceId(interval))}
                title={t("stepFivePricesCotent1", { interval })}
                label={t("stepFivePricesCotent2", { interval })}
                full_price={GetPlanFullPrice(interval)}
                discount_price={GetPlanFullPrice(interval) * (1 - discount)}
              />
            ))}
        </SimpleGrid>{" "}
        {!subscription_plan?.subscription_plan_prices.length && (
          <Center w="full">
            <Text>
              {t("errorMessage3")}
            </Text>
          </Center>
        )}
      </>
    );
  }
);

export default Prices;
